import { api } from '../api'
import { ILegalPerson, ILegalPersonPayment, ITable, ServerResponse } from '../../models/models'
import { legalPersonsInputs } from '../../constants/legalPersonsPage'

export const legalPersonsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getLegalPersons: builder.query<ITable<ILegalPerson>, any>({
			query: (params) => ({
				url: 'legal-persons',
				params: {
					...params,
					showOnlyCompanies: true,
				},
			}),
			providesTags: ['legalPerson'],
			transformResponse: (response: ServerResponse<ITable<ILegalPerson>>) => response.data,
		}),
		getLegalPersonById: builder.query<ILegalPerson, { id: string | number }>({
			query: ({ id }) => ({
				url: `legal-persons/${id}`,
			}),
			providesTags: ['legalPerson'],
			transformResponse: (response: ServerResponse<ILegalPerson>) => ({
				...response.data,
				overdraftAmount: response.data?.overdraftAmount ? response.data?.overdraftAmount / 100 : 0,
				lowerLimit: response.data?.lowerLimit ? response.data?.lowerLimit / 100 : 0,
				discountPerLiter: response.data?.discountPerLiter ? response.data?.discountPerLiter / 100 : 0,
			}),
		}),
		editLegalPerson: builder.mutation<ILegalPerson, { id: string | number; data: legalPersonsInputs & { regionId: number } }>({
			query: (body) => ({
				url: `legal-persons/${body.id}`,
				method: 'PUT',
				body: body.data,
			}),
			invalidatesTags: ['fop', 'legalPerson'],
			transformResponse: (response: ServerResponse<ILegalPerson>) => response.data,
		}),
		changeLegalPersonStatus: builder.mutation<ILegalPerson, { id: string | number }>({
			query: (body) => ({
				url: `legal-persons/${body.id}/status`,
				method: 'PUT',
			}),
			invalidatesTags: ['fop', 'legalPerson'],
			transformResponse: (response: ServerResponse<ILegalPerson>) => response.data,
		}),
		getLegalPersonPayments: builder.query<ITable<ILegalPersonPayment>, any>({
			query: ({ id, ...params }) => ({
				url: `legal-persons/${id}/payments`,
				params,
			}),
			transformResponse: (response: ServerResponse<ITable<ILegalPersonPayment>>) => response.data,
		}),
		changeVisibleLegalPersons: builder.mutation<ServerResponse<ITable<any>>, any>({
			query: (body) => ({
				url: 'legal-persons/companies/view',
				method: 'PUT',
				body,
			}),
		}),
		toggleDiscount: builder.mutation<ServerResponse<ILegalPerson>, { id: string | number }>({
			query: ({ id }) => ({
				url: `legal-persons/${id}/discount-card`,
				method: 'PUT',
			}),
			invalidatesTags: ['fop', 'legalPerson'],
		}),
	}),
})

export const {
	useGetLegalPersonsQuery,
	useGetLegalPersonByIdQuery,
	useEditLegalPersonMutation,
	useChangeLegalPersonStatusMutation,
	useGetLegalPersonPaymentsQuery,
	useChangeVisibleLegalPersonsMutation,
	useToggleDiscountMutation,
} = legalPersonsApi
